/* Subnavigation Menu - updated 4/22/2020 to fix bottom scroll  */

var subnavMenuScroll = {

  init: function(subnavMenu){
    this.subnav = {
      menu: subnavMenu,
      parallax: new Rellax('.wex-subnav-menu', {
        speed: -1,
      })
    };

    this.accordion = {
      element: subnavMenu.find('.wex-accordion'),
      options: {allowAllClosed: true},
      breakpoints: ['small', 'medium', 'large', 'xlarge'],
    };

    this.scrollNav = {
      breakpoints: ['xxlarge', 'xxxlarge', 'xxxxlarge'],
    };

    // Init binding
    this.bindUIevents(subnavMenu, this.accordion, this.scrollNav);

  },

  bindUIevents: function(subnavMenu, accordion, scrollNav){

    // when window loads -- if small through xlarge...
    if ($.inArray(Foundation.MediaQuery.current, accordion.breakpoints) >= 0) {
      // initialize accordion
      new Foundation.Accordion(accordion.element, accordion.options);
      subnavMenuScroll.subnav.parallax.destroy(); // turn off rellax for mobile

    } else {

      // initialize scroll events
      $(document).on('scroll', subnavMenuScroll.navScroll);

      // On load of page - determine height of subnav and first section's min height larger so that there isn't overlapping in the footer
      var minSubnavHeight = subnavMenuScroll.subnav.menu.height() + 200;
      $('#mainContent').css('min-height', minSubnavHeight);


    }

    // when the breakpoints change...
    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){

      // if small through xlarge and coming from large breakpoint
      if (($.inArray(newSize, accordion.breakpoints) >= 0) && ($.inArray(oldSize, scrollNav.breakpoints) >= 0)) {

        // initialize accordion
        new Foundation.Accordion(accordion.element, accordion.options);

        // destroy rellax
        subnavMenuScroll.subnav.parallax.destroy();

        // stop scroll events
        subnavMenuScroll.destroyScroll(subnavMenu, scrollNav);


      // if xxlarge through xxxxlarge and coming from smaller breakpoint
      } else if (($.inArray(oldSize, accordion.breakpoints) >= 0) && ($.inArray(newSize, scrollNav.breakpoints) >= 0)) {

        // destroy accordion
        accordion.element.foundation('_destroy');

        // initialize rellax
        subnavMenuScroll.subnav.parallax.refresh();

        // start scroll events
        $(document).on('scroll', subnavMenuScroll.navScroll);
      }
    });

  },

  navScroll: function(scrollNav) {

    var position = subnavMenuScroll.subnav.menu.offset().top + 18, // 18 added to add in margin applied to subnav
       //headerHeight = $('.wex-header').height() + $('.wex-hero').height() + 54, // 54 added to compensate for the rellax parallax effect movement
       headerHeight = $('.wex-header').height() + 54, // 54 added to compensate for the rellax parallax effect movement
       footerPosition,
       subMenuContainerTop;

    subMenuContainerTop = $('.wex-subnav-menu').parent().eq(0).offset().top;

    if ($('.wex-footer-cta').length !== 0) {
      footerPosition = $('.wex-footer-cta').offset().top; // based on position of the cta bar
    } else {
      footerPosition = $('.wex-footer').offset().top; // based on position of the footer if there is no CTA bar
    }

    if ( (  $('.wex-subnav-menu').offset().top - $(window).scrollTop()  )  <= headerHeight  && !subnavMenuScroll.subnav.menu.hasClass('fixed') && !subnavMenuScroll.subnav.menu.hasClass('bottom')) {

      // as the Subnav Menu scrolls to footer, once the top of the browser is touching its container, it will assume a fixed position
      subnavMenuScroll.subnav.menu.addClass('fixed');
      subnavMenuScroll.subnav.parallax.destroy();

    } else if ($('.wex-subnav-menu').offset().top + $('.wex-subnav-menu').outerHeight() + 18 > footerPosition && !subnavMenuScroll.subnav.menu.hasClass('bottom')) {

      // As the subnav gets to the footer container, once it is 38px above it, it becomes fixed to its position and will not scroll further
      subnavMenuScroll.subnav.menu.css({'top': footerPosition - $('.wex-subnav-menu').outerHeight() - 18, 'position': 'absolute'}).removeClass('fixed').addClass('bottom');

    } else if ( ( subMenuContainerTop - $(window).scrollTop()  ) >= headerHeight  && subnavMenuScroll.subnav.menu.hasClass('fixed')) {

      // restore subnav styles when you scroll up
      subnavMenuScroll.subnav.menu.removeClass('fixed');
      subnavMenuScroll.subnav.parallax.refresh();

    } else if (subnavMenuScroll.subnav.menu.hasClass('bottom') && $(window).scrollTop() + 184 <= footerPosition - $('.wex-subnav-menu').outerHeight() - 18) {

      // As the window scroll gets lesser than the absolute position nav with class bottom, remove the class bottom and convert to fixed
      subnavMenuScroll.subnav.menu.removeClass('bottom').css({'top': '', 'position': ''});
      subnavMenuScroll.subnav.menu.addClass('fixed');
    }

  },

  destroyScroll: function(scrollNav){
    $(document).off('scroll', subnavMenuScroll.navScroll);
  },
};

if ($('.wex-subnav-menu').length !== 0) {
  subnavMenuScroll.init($('.wex-subnav-menu'));

  $('.wex-subnav-menu').find('.current_page_item').addClass('active');
/*
  $('.wex-subnav-menu').find('.current_page_item').attr({
    'aria-current': 'page'
  }).addClass('active');
*/
}
